/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/home/home.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../../../../public/upgrade/feature/home/home.service';
import * as import9 from '../../../../../public/upgrade/root/ga/ga.service';
import * as import10 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '@angular/router/src/router';
import * as import13 from '@ngx-translate/core/src/translate.service';
import * as import14 from '@angular/core/src/zone/ng_zone';
import * as import15 from '../../../../../public/upgrade/core/contract.service';
import * as import16 from '../../../../../public/upgrade/core/legal_document_service';
import * as import17 from 'ngx-cookie/src/cookie.service';
import * as import18 from '../../../../../public/upgrade/core/session.service';
import * as import19 from '../../../../../public/upgrade/root/toast/notification.service';
import * as import20 from '../../../../../public/upgrade/core/contract_states.service';
import * as import21 from '@ngx-translate/core/src/translate.pipe';
import * as import22 from '@angular/core/src/linker/view_container';
import * as import23 from '@angular/core/src/change_detection/change_detection_util';
import * as import24 from '@angular/core/src/security';
import * as import25 from '@angular/core/src/linker/query_list';
import * as import26 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import27 from '../../../../../public/upgrade/feature/home/pickup-week/pickup-week.component';
import * as import28 from '../../../../../public/upgrade/core/date.service';
import * as import29 from './pickup-week/pickup-week.component.ngfactory';
import * as import30 from '@angular/core/src/linker/template_ref';
import * as import31 from '@angular/common/src/directives/ng_if';
import * as import32 from '@angular/core/src/linker/element_ref';
export class Wrapper_HomeComponent {
  /*private*/ _eventHandler:Function;
  context:import0.HomeComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any,p11:any,p12:any) {
    this._changed = false;
    this.context = new import0.HomeComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_HomeComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_HomeComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.HomeComponent>;
  _HomeComponent_0_3:Wrapper_HomeComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_HomeComponent_Host0,renderType_HomeComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'home',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_HomeComponent0(this.viewUtils,this,0,this._el_0);
    this._HomeComponent_0_3 = new Wrapper_HomeComponent(this.injectorGet(import8.HomeService,this.parentIndex),this.injectorGet(import9.GAService,this.parentIndex),this.injectorGet(import10.LoadingWheelService,this.parentIndex),this.injectorGet(import11.ActivatedRoute,this.parentIndex),this.injectorGet(import12.Router,this.parentIndex),this.injectorGet(import13.TranslateService,this.parentIndex),this.injectorGet(import14.NgZone,this.parentIndex),this.injectorGet(import15.ContractService,this.parentIndex),this.injectorGet(import16.LegalDocumentService,this.parentIndex),this.injectorGet(import17.CookieService,this.parentIndex),this.injectorGet(import18.SessionService,this.parentIndex),this.injectorGet(import19.NotificationService,this.parentIndex),this.injectorGet(import20.ContractStatesService,this.parentIndex));
    this.compView_0.create(this._HomeComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._HomeComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.HomeComponent) && (0 === requestNodeIndex))) { return this._HomeComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._HomeComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._HomeComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const HomeComponentNgFactory:import7.ComponentFactory<import0.HomeComponent> = new import7.ComponentFactory<import0.HomeComponent>('home',View_HomeComponent_Host0,import0.HomeComponent);
const styles_HomeComponent:any[] = ([] as any[]);
class View_HomeComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import21.TranslatePipe;
  /*private*/ _expr_15:any;
  /*private*/ _expr_16:any;
  /*private*/ _expr_17:any;
  _pipe_translate_1:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_HomeComponent1,renderType_HomeComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_13 = import23.UNINITIALIZED;
    this._expr_15 = import23.UNINITIALIZED;
    this._expr_16 = import23.UNINITIALIZED;
    this._expr_17 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-message -no-title -error message-banner-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','message-icon-container message-banner-icon-container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','message-icon eva-3-icon-error-circle'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','message-text eva-3-p message-text-padding'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'a',new import3.InlineArray2(2,'class','link-banner'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,'\n                                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('contract.terms.banner.message.expired')),'\n                                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_7,currVal_13);
      this._expr_13 = currVal_13;
    }
    const currVal_15:any = ('mailto:' + this.parentView.context.emailExecutiveAccount);
    if (import3.checkBinding(throwOnChange,this._expr_15,currVal_15)) {
      this.renderer.setElementProperty(this._el_8,'href',this.viewUtils.sanitizer.sanitize(import24.SecurityContext.URL,currVal_15));
      this._expr_15 = currVal_15;
    }
    const currVal_16:any = import3.inlineInterpolate(1,'',this.parentView.context.emailExecutiveAccount,'');
    if (import3.checkBinding(throwOnChange,this._expr_16,currVal_16)) {
      this.renderer.setText(this._text_9,currVal_16);
      this._expr_16 = currVal_16;
    }
    valUnwrapper.reset();
    const currVal_17:any = import3.inlineInterpolate(1,'\n                                ',valUnwrapper.unwrap(this._pipe_translate_1.transform('contract.terms.banner.message.expired2')),'\n                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_17,currVal_17))) {
      this.renderer.setText(this._text_10,currVal_17);
      this._expr_17 = currVal_17;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_HomeComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  /*private*/ _expr_15:any;
  _pipe_translate_0:import21.TranslatePipe;
  /*private*/ _expr_17:any;
  _pipe_translate_1:import21.TranslatePipe;
  _pipe_translate_2:import21.TranslatePipe;
  _map_20:any;
  _pipe_translate_3:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_HomeComponent2,renderType_HomeComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_15 = import23.UNINITIALIZED;
    this._expr_17 = import23.UNINITIALIZED;
    this._map_20 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {countryPhone: p0};
    });
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-dashboard-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','header'),(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,this._el_2,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'26/03/2020',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','body'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                    ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h4',new import3.InlineArray2(2,'class','eva-3-h4'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n                                    ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_6,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-2 -eva-3-mt-sm eva-3-p'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n                                ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_0.transform('home.communications.NEWS_11_TITLE')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_9,currVal_15);
      this._expr_15 = currVal_15;
    }
    valUnwrapper.reset();
    const currVal_17:any = import3.inlineInterpolate(3,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_1.transform('home.communications.NEWS_11_DESCRIPTION_01')),'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_2.transform(('home.communications.NEWS_11_COUNTRY_' + this.parentView.context.countryCode))),'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_3.transform('home.communications.NEWS_11_DESCRIPTION_02',this._map_20(this.parentView.context.countryPhone))),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_17,currVal_17))) {
      this.renderer.setText(this._text_12,currVal_17);
      this._expr_17 = currVal_17;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_HomeComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_HomeComponent,{});
export class View_HomeComponent0 extends import1.AppView<import0.HomeComponent> {
  _viewQuery_dspCards_0:import25.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _vc_11:import22.ViewContainer;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import26.Wrapper_NgIf;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _el_29:any;
  _text_30:any;
  _el_31:any;
  compView_31:import1.AppView<import27.PickupWeekComponent>;
  _DateService_31_3:import28.DateService;
  _PickupWeekComponent_31_4:import29.Wrapper_PickupWeekComponent;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _text_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _el_52:any;
  _text_53:any;
  _el_54:any;
  _el_55:any;
  _text_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _el_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _text_71:any;
  _text_72:any;
  _text_73:any;
  _text_74:any;
  _el_75:any;
  _text_76:any;
  _anchor_77:any;
  /*private*/ _vc_77:import22.ViewContainer;
  _TemplateRef_77_5:any;
  _NgIf_77_6:import26.Wrapper_NgIf;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _el_84:any;
  _el_85:any;
  _text_86:any;
  _text_87:any;
  _el_88:any;
  _text_89:any;
  _el_90:any;
  _text_91:any;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _text_95:any;
  _text_96:any;
  _el_97:any;
  _text_98:any;
  _el_99:any;
  _text_100:any;
  _text_101:any;
  _text_102:any;
  _text_103:any;
  _text_104:any;
  _el_105:any;
  _text_106:any;
  _el_107:any;
  _text_108:any;
  _el_109:any;
  _el_110:any;
  _text_111:any;
  _text_112:any;
  _el_113:any;
  _text_114:any;
  _el_115:any;
  _text_116:any;
  _text_117:any;
  _el_118:any;
  _text_119:any;
  _text_120:any;
  _text_121:any;
  _el_122:any;
  _text_123:any;
  _el_124:any;
  _text_125:any;
  _text_126:any;
  _text_127:any;
  _text_128:any;
  _text_129:any;
  _text_130:any;
  _text_131:any;
  _text_132:any;
  _text_133:any;
  _text_134:any;
  _text_135:any;
  _text_136:any;
  _el_137:any;
  _text_138:any;
  _el_139:any;
  _text_140:any;
  _el_141:any;
  _el_142:any;
  _text_143:any;
  _el_144:any;
  _el_145:any;
  _text_146:any;
  _el_147:any;
  _text_148:any;
  _el_149:any;
  _text_150:any;
  _el_151:any;
  _text_152:any;
  _text_153:any;
  _text_154:any;
  _el_155:any;
  _text_156:any;
  _el_157:any;
  _text_158:any;
  _el_159:any;
  _el_160:any;
  _text_161:any;
  _text_162:any;
  _text_163:any;
  _el_164:any;
  _text_165:any;
  _el_166:any;
  _text_167:any;
  _el_168:any;
  _text_169:any;
  _text_170:any;
  _text_171:any;
  _text_172:any;
  _text_173:any;
  _text_174:any;
  _el_175:any;
  _text_176:any;
  _el_177:any;
  _text_178:any;
  _el_179:any;
  _el_180:any;
  _text_181:any;
  _el_182:any;
  _el_183:any;
  _text_184:any;
  _el_185:any;
  _text_186:any;
  _el_187:any;
  _text_188:any;
  _text_189:any;
  _el_190:any;
  _text_191:any;
  _text_192:any;
  _text_193:any;
  _el_194:any;
  _text_195:any;
  _el_196:any;
  _el_197:any;
  _text_198:any;
  _text_199:any;
  _el_200:any;
  _el_201:any;
  _text_202:any;
  _el_203:any;
  _text_204:any;
  _text_205:any;
  _text_206:any;
  _el_207:any;
  _text_208:any;
  _el_209:any;
  _text_210:any;
  _text_211:any;
  _text_212:any;
  _text_213:any;
  _text_214:any;
  /*private*/ _expr_225:any;
  _pipe_translate_0:import21.TranslatePipe;
  /*private*/ _expr_227:any;
  _pipe_translate_1:import21.TranslatePipe;
  /*private*/ _expr_229:any;
  _pipe_translate_2:import21.TranslatePipe;
  _pipe_translate_3:import21.TranslatePipe;
  /*private*/ _expr_232:any;
  _pipe_translate_4:import21.TranslatePipe;
  /*private*/ _expr_234:any;
  _pipe_translate_5:import21.TranslatePipe;
  /*private*/ _expr_236:any;
  _pipe_translate_6:import21.TranslatePipe;
  /*private*/ _expr_238:any;
  _pipe_translate_7:import21.TranslatePipe;
  /*private*/ _expr_240:any;
  _pipe_translate_8:import21.TranslatePipe;
  /*private*/ _expr_242:any;
  _pipe_translate_9:import21.TranslatePipe;
  /*private*/ _expr_244:any;
  _pipe_translate_10:import21.TranslatePipe;
  /*private*/ _expr_246:any;
  _pipe_translate_11:import21.TranslatePipe;
  /*private*/ _expr_248:any;
  _pipe_translate_12:import21.TranslatePipe;
  /*private*/ _expr_250:any;
  _pipe_translate_13:import21.TranslatePipe;
  /*private*/ _expr_252:any;
  _pipe_translate_14:import21.TranslatePipe;
  /*private*/ _expr_254:any;
  _pipe_translate_15:import21.TranslatePipe;
  /*private*/ _expr_256:any;
  _pipe_translate_16:import21.TranslatePipe;
  /*private*/ _expr_258:any;
  _pipe_translate_17:import21.TranslatePipe;
  /*private*/ _expr_260:any;
  _pipe_translate_18:import21.TranslatePipe;
  /*private*/ _expr_262:any;
  _pipe_translate_19:import21.TranslatePipe;
  /*private*/ _expr_264:any;
  _pipe_translate_20:import21.TranslatePipe;
  /*private*/ _expr_266:any;
  _pipe_translate_21:import21.TranslatePipe;
  /*private*/ _expr_268:any;
  /*private*/ _expr_269:any;
  _pipe_translate_22:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_HomeComponent0,renderType_HomeComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
    this._expr_225 = import23.UNINITIALIZED;
    this._expr_227 = import23.UNINITIALIZED;
    this._expr_229 = import23.UNINITIALIZED;
    this._expr_232 = import23.UNINITIALIZED;
    this._expr_234 = import23.UNINITIALIZED;
    this._expr_236 = import23.UNINITIALIZED;
    this._expr_238 = import23.UNINITIALIZED;
    this._expr_240 = import23.UNINITIALIZED;
    this._expr_242 = import23.UNINITIALIZED;
    this._expr_244 = import23.UNINITIALIZED;
    this._expr_246 = import23.UNINITIALIZED;
    this._expr_248 = import23.UNINITIALIZED;
    this._expr_250 = import23.UNINITIALIZED;
    this._expr_252 = import23.UNINITIALIZED;
    this._expr_254 = import23.UNINITIALIZED;
    this._expr_256 = import23.UNINITIALIZED;
    this._expr_258 = import23.UNINITIALIZED;
    this._expr_260 = import23.UNINITIALIZED;
    this._expr_262 = import23.UNINITIALIZED;
    this._expr_264 = import23.UNINITIALIZED;
    this._expr_266 = import23.UNINITIALIZED;
    this._expr_268 = import23.UNINITIALIZED;
    this._expr_269 = import23.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_dspCards_0 = new import25.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start reset-styles'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-container -eva-3-p-md -eva-3-m-xlg'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -md-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_8,(null as any));
    this._vc_11 = new import22.ViewContainer(11,8,this,this._anchor_11);
    this._TemplateRef_11_5 = new import30.TemplateRef_(this,11,this._anchor_11);
    this._NgIf_11_6 = new import26.Wrapper_NgIf(this._vc_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_8,'\n\n                    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','col -md-9 home-welcome-company'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'span',new import3.InlineArray2(2,'class','eva-3-h1'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_13,'\n                    ',(null as any));
    this._text_18 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','col -md-3 home-welcome-date'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                        ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'p',new import3.InlineArray2(2,'class','-eva-3-mb-md'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'',(null as any));
    this._text_23 = this.renderer.createText(this._el_19,'\n                        ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_19,'p',new import3.InlineArray2(2,'class','-eva-3-mb-md'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'',(null as any));
    this._text_26 = this.renderer.createText(this._el_19,'\n                    ',(null as any));
    this._text_27 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_28 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-xlg'),(null as any));
    this._text_30 = this.renderer.createText(this._el_29,'\n                    ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_29,'pickup-week',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_31 = new import29.View_PickupWeekComponent0(this.viewUtils,this,31,this._el_31);
    this._DateService_31_3 = new import28.DateService();
    this._PickupWeekComponent_31_4 = new import29.Wrapper_PickupWeekComponent(this.parentView.injectorGet(import9.GAService,this.parentIndex),this.parentView.injectorGet(import11.ActivatedRoute,this.parentIndex),this._DateService_31_3);
    this.compView_31.create(this._PickupWeekComponent_31_4.context);
    this._text_32 = this.renderer.createText(this._el_29,'\n                ',(null as any));
    this._text_33 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-lg -eva-3-mt-lg home-container-suppliers'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'\n                    ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_34,'div',new import3.InlineArray2(2,'class','-lg-12 -md-12 -sm-12 -eva-3-mt-sm'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                        ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mb-md'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                            ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_38,'div',new import3.InlineArray2(2,'class','-sm-12 -md-12 -lg-12'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                                ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'\n                                    ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'h5',new import3.InlineArray2(2,'class','-h5'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(this._el_42,'\n                                ',(null as any));
    this._text_47 = this.renderer.createText(this._el_40,'\n                            ',(null as any));
    this._text_48 = this.renderer.createText(this._el_38,'\n                        ',(null as any));
    this._text_49 = this.renderer.createText(this._el_36,'\n                        ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_36,'div',new import3.InlineArray2(2,'class','-eva-3-mb-md'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'\n                            ',(null as any));
    this._el_52 = import3.createRenderElement(this.renderer,this._el_50,'dsp-dashboard-card',new import3.InlineArray2(2,'image-aside','https://media.staticontent.com/media/pictures/f6145455-f73d-402c-b245-d202539ac928'),(null as any));
    this._text_53 = this.renderer.createText(this._el_52,'\n                                ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_52,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','header'),(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_54,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'',(null as any));
    this._text_57 = this.renderer.createText(this._el_52,'\n                                ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_52,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','body'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'\n                                    ',(null as any));
    this._el_60 = import3.createRenderElement(this.renderer,this._el_58,'h4',new import3.InlineArray2(2,'class','eva-3-h4'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'',(null as any));
    this._text_62 = this.renderer.createText(this._el_58,'\n                                    ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_58,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-2 -eva-3-mt-sm eva-3-p'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'',(null as any));
    this._text_65 = this.renderer.createText(this._el_58,'\n                                ',(null as any));
    this._text_66 = this.renderer.createText(this._el_52,'\n                                ',(null as any));
    this._el_67 = import3.createRenderElement(this.renderer,this._el_52,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg -eva-3-mb-lg','slot','footer'),(null as any));
    this._text_68 = this.renderer.createText(this._el_67,'\n                                    ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_67,'button',new import3.InlineArray4(4,'class','eva-3-btn-ghost -md -ghost -blue','qadata','home-news'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'',(null as any));
    this._text_71 = this.renderer.createText(this._el_67,'\n                                ',(null as any));
    this._text_72 = this.renderer.createText(this._el_52,'\n                            ',(null as any));
    this._text_73 = this.renderer.createText(this._el_50,'\n                        ',(null as any));
    this._text_74 = this.renderer.createText(this._el_36,'\n                        ',(null as any));
    this._el_75 = import3.createRenderElement(this.renderer,this._el_36,'div',new import3.InlineArray2(2,'class','-eva-3-mb-md'),(null as any));
    this._text_76 = this.renderer.createText(this._el_75,'\n                            ',(null as any));
    this._anchor_77 = this.renderer.createTemplateAnchor(this._el_75,(null as any));
    this._vc_77 = new import22.ViewContainer(77,75,this,this._anchor_77);
    this._TemplateRef_77_5 = new import30.TemplateRef_(this,77,this._anchor_77);
    this._NgIf_77_6 = new import26.Wrapper_NgIf(this._vc_77.vcRef,this._TemplateRef_77_5);
    this._text_78 = this.renderer.createText(this._el_75,'\n                        ',(null as any));
    this._text_79 = this.renderer.createText(this._el_36,'\n\n                        ',(null as any));
    this._el_80 = import3.createRenderElement(this.renderer,this._el_36,'div',new import3.InlineArray2(2,'class','-eva-3-mb-md'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_82 = import3.createRenderElement(this.renderer,this._el_80,'dsp-dashboard-card',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'\n                                ',(null as any));
    this._el_84 = import3.createRenderElement(this.renderer,this._el_82,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','header'),(null as any));
    this._el_85 = import3.createRenderElement(this.renderer,this._el_84,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_86 = this.renderer.createText(this._el_85,'30/01/2020',(null as any));
    this._text_87 = this.renderer.createText(this._el_82,'\n                                ',(null as any));
    this._el_88 = import3.createRenderElement(this.renderer,this._el_82,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','body'),(null as any));
    this._text_89 = this.renderer.createText(this._el_88,'\n                                    ',(null as any));
    this._el_90 = import3.createRenderElement(this.renderer,this._el_88,'h4',new import3.InlineArray2(2,'class','eva-3-h4'),(null as any));
    this._text_91 = this.renderer.createText(this._el_90,'',(null as any));
    this._text_92 = this.renderer.createText(this._el_88,'\n                                    ',(null as any));
    this._el_93 = import3.createRenderElement(this.renderer,this._el_88,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-2 -eva-3-mt-sm eva-3-p'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'',(null as any));
    this._text_95 = this.renderer.createText(this._el_88,'\n                                ',(null as any));
    this._text_96 = this.renderer.createText(this._el_82,'\n                                ',(null as any));
    this._el_97 = import3.createRenderElement(this.renderer,this._el_82,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg -eva-3-mb-lg','slot','footer'),(null as any));
    this._text_98 = this.renderer.createText(this._el_97,'\n                                    ',(null as any));
    this._el_99 = import3.createRenderElement(this.renderer,this._el_97,'button',new import3.InlineArray4(4,'class','eva-3-btn-ghost -md -ghost -blue -eva-3-mt-lg','qadata','home-news-1'),(null as any));
    this._text_100 = this.renderer.createText(this._el_99,'',(null as any));
    this._text_101 = this.renderer.createText(this._el_97,'\n                                ',(null as any));
    this._text_102 = this.renderer.createText(this._el_82,'\n                            ',(null as any));
    this._text_103 = this.renderer.createText(this._el_80,'\n                        ',(null as any));
    this._text_104 = this.renderer.createText(this._el_36,'\n\n                        ',(null as any));
    this._el_105 = import3.createRenderElement(this.renderer,this._el_36,'div',new import3.InlineArray2(2,'class','-eva-3-mb-md'),(null as any));
    this._text_106 = this.renderer.createText(this._el_105,'\n                            ',(null as any));
    this._el_107 = import3.createRenderElement(this.renderer,this._el_105,'dsp-dashboard-card',new import3.InlineArray2(2,'image-aside','http://media.staticontent.com/media/pictures/3aea114a-96bd-46fe-8154-c1806d65a214'),(null as any));
    this._text_108 = this.renderer.createText(this._el_107,'\n                                ',(null as any));
    this._el_109 = import3.createRenderElement(this.renderer,this._el_107,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','header'),(null as any));
    this._el_110 = import3.createRenderElement(this.renderer,this._el_109,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_111 = this.renderer.createText(this._el_110,'26/08/2019',(null as any));
    this._text_112 = this.renderer.createText(this._el_107,'\n                                ',(null as any));
    this._el_113 = import3.createRenderElement(this.renderer,this._el_107,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg','slot','body'),(null as any));
    this._text_114 = this.renderer.createText(this._el_113,'\n                                    ',(null as any));
    this._el_115 = import3.createRenderElement(this.renderer,this._el_113,'h4',new import3.InlineArray2(2,'class','eva-3-h4'),(null as any));
    this._text_116 = this.renderer.createText(this._el_115,'',(null as any));
    this._text_117 = this.renderer.createText(this._el_113,'\n                                    ',(null as any));
    this._el_118 = import3.createRenderElement(this.renderer,this._el_113,'p',new import3.InlineArray2(2,'class','-eva-3-tc-gray-2 -eva-3-mt-sm eva-3-p'),(null as any));
    this._text_119 = this.renderer.createText(this._el_118,'',(null as any));
    this._text_120 = this.renderer.createText(this._el_113,'\n                                ',(null as any));
    this._text_121 = this.renderer.createText(this._el_107,'\n                                ',(null as any));
    this._el_122 = import3.createRenderElement(this.renderer,this._el_107,'div',new import3.InlineArray4(4,'class','-eva-3-ml-lg -eva-3-mb-lg','slot','footer'),(null as any));
    this._text_123 = this.renderer.createText(this._el_122,'\n                                    ',(null as any));
    this._el_124 = import3.createRenderElement(this.renderer,this._el_122,'button',new import3.InlineArray4(4,'class','eva-3-btn-ghost -md -ghost -blue -eva-3-mt-xs','qadata','home-news-2'),(null as any));
    this._text_125 = this.renderer.createText(this._el_124,'',(null as any));
    this._text_126 = this.renderer.createText(this._el_122,'\n                                ',(null as any));
    this._text_127 = this.renderer.createText(this._el_107,'\n                            ',(null as any));
    this._text_128 = this.renderer.createText(this._el_105,'\n                        ',(null as any));
    this._text_129 = this.renderer.createText(this._el_36,'\n                    ',(null as any));
    this._text_130 = this.renderer.createText(this._el_34,'\n                ',(null as any));
    this._text_131 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_132 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_133 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_134 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_135 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._text_136 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_137 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','eva-3-modal eva-3-modal--coachmark -sm ','id','modalNewFeatureTyC'),(null as any));
    this._text_138 = this.renderer.createText(this._el_137,'\n    ',(null as any));
    this._el_139 = import3.createRenderElement(this.renderer,this._el_137,'div',new import3.InlineArray2(2,'class','modal-content modal-new-feature-tyc'),(null as any));
    this._text_140 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_141 = import3.createRenderElement(this.renderer,this._el_139,'div',new import3.InlineArray2(2,'class','modal-coachmark-img-container padding-modal'),(null as any));
    this._el_142 = import3.createRenderElement(this.renderer,this._el_141,'i',new import3.InlineArray2(2,'class','modal-close eva-3-icon-close icon-close-modal'),(null as any));
    this._text_143 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_144 = import3.createRenderElement(this.renderer,this._el_139,'div',new import3.InlineArray2(2,'class','modal-coachmark-img-container padding-modal'),(null as any));
    this._el_145 = import3.createRenderElement(this.renderer,this._el_144,'img',new import3.InlineArray8(8,'class','center','height','116px','src','http://media.staticontent.com/media/pictures/8e58424f-86b8-4f2c-8277-29925c150ea1','width','250px'),(null as any));
    this._text_146 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_147 = import3.createRenderElement(this.renderer,this._el_139,'br',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_148 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_149 = import3.createRenderElement(this.renderer,this._el_139,'div',new import3.InlineArray2(2,'class','modal-coachmark-title padding-modal'),(null as any));
    this._text_150 = this.renderer.createText(this._el_149,'\n            ',(null as any));
    this._el_151 = import3.createRenderElement(this.renderer,this._el_149,'h4',new import3.InlineArray2(2,'class','eva-3-h4 center'),(null as any));
    this._text_152 = this.renderer.createText(this._el_151,'',(null as any));
    this._text_153 = this.renderer.createText(this._el_149,'\n        ',(null as any));
    this._text_154 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_155 = import3.createRenderElement(this.renderer,this._el_139,'br',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_156 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_157 = import3.createRenderElement(this.renderer,this._el_139,'div',new import3.InlineArray2(2,'class','modal-coachmark-description center padding-modal'),(null as any));
    this._text_158 = this.renderer.createText(this._el_157,'\n            ',(null as any));
    this._el_159 = import3.createRenderElement(this.renderer,this._el_157,'h5',new import3.InlineArray2(2,'class','eva-3-h5 center'),(null as any));
    this._el_160 = import3.createRenderElement(this.renderer,this._el_159,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_161 = this.renderer.createText(this._el_160,'',(null as any));
    this._text_162 = this.renderer.createText(this._el_157,'\n        ',(null as any));
    this._text_163 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_164 = import3.createRenderElement(this.renderer,this._el_139,'br',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_165 = this.renderer.createText(this._el_139,'\n        ',(null as any));
    this._el_166 = import3.createRenderElement(this.renderer,this._el_139,'div',new import3.InlineArray2(2,'class','modal-coachmark-actions'),(null as any));
    this._text_167 = this.renderer.createText(this._el_166,'\n            ',(null as any));
    this._el_168 = import3.createRenderElement(this.renderer,this._el_166,'button',new import3.InlineArray2(2,'class','eva-3-btn-ghost -lg -eva-3-fwidth-small -darken center'),(null as any));
    this._text_169 = this.renderer.createText(this._el_168,'',(null as any));
    this._text_170 = this.renderer.createText(this._el_166,'\n        ',(null as any));
    this._text_171 = this.renderer.createText(this._el_139,'\n    ',(null as any));
    this._text_172 = this.renderer.createText(this._el_137,'\n',(null as any));
    this._text_173 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._text_174 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_175 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','eva-3-modal eva-3-modal--coachmark -sm ','id','modalContractExpired'),(null as any));
    this._text_176 = this.renderer.createText(this._el_175,'\n    ',(null as any));
    this._el_177 = import3.createRenderElement(this.renderer,this._el_175,'div',new import3.InlineArray2(2,'class','modal-content modal-contract-expired'),(null as any));
    this._text_178 = this.renderer.createText(this._el_177,'\n        ',(null as any));
    this._el_179 = import3.createRenderElement(this.renderer,this._el_177,'div',new import3.InlineArray2(2,'class','modal-coachmark-img-container padding-modal'),(null as any));
    this._el_180 = import3.createRenderElement(this.renderer,this._el_179,'i',new import3.InlineArray2(2,'class','modal-close eva-3-icon-close icon-close-modal'),(null as any));
    this._text_181 = this.renderer.createText(this._el_177,'\n        ',(null as any));
    this._el_182 = import3.createRenderElement(this.renderer,this._el_177,'div',new import3.InlineArray2(2,'class','modal-coachmark-img-container padding-modal'),(null as any));
    this._el_183 = import3.createRenderElement(this.renderer,this._el_182,'img',new import3.InlineArray8(8,'class','center','height','120px','src','http://media.staticontent.com/media/pictures/37235442-6706-4930-ad2f-e559cd6a7f71','width','238px'),(null as any));
    this._text_184 = this.renderer.createText(this._el_177,'\n        ',(null as any));
    this._el_185 = import3.createRenderElement(this.renderer,this._el_177,'div',new import3.InlineArray2(2,'class','modal-coachmark-title padding-modal'),(null as any));
    this._text_186 = this.renderer.createText(this._el_185,'\n            ',(null as any));
    this._el_187 = import3.createRenderElement(this.renderer,this._el_185,'h4',new import3.InlineArray2(2,'class','eva-3-h4 center h4-modal-new-feature'),(null as any));
    this._text_188 = this.renderer.createText(this._el_187,'',(null as any));
    this._text_189 = this.renderer.createText(this._el_185,'\n            ',(null as any));
    this._el_190 = import3.createRenderElement(this.renderer,this._el_185,'h4',new import3.InlineArray2(2,'class','eva-3-h4 center h4-sec-modal-new-feature'),(null as any));
    this._text_191 = this.renderer.createText(this._el_190,'',(null as any));
    this._text_192 = this.renderer.createText(this._el_185,'\n        ',(null as any));
    this._text_193 = this.renderer.createText(this._el_177,'\n        ',(null as any));
    this._el_194 = import3.createRenderElement(this.renderer,this._el_177,'div',new import3.InlineArray2(2,'class','modal-coachmark-description center container-modal-new-feature'),(null as any));
    this._text_195 = this.renderer.createText(this._el_194,'\n            ',(null as any));
    this._el_196 = import3.createRenderElement(this.renderer,this._el_194,'h5',new import3.InlineArray2(2,'class','eva-3-h5 center'),(null as any));
    this._el_197 = import3.createRenderElement(this.renderer,this._el_196,'span',new import3.InlineArray2(2,'class','span-modal-new-feature'),(null as any));
    this._text_198 = this.renderer.createText(this._el_197,'',(null as any));
    this._text_199 = this.renderer.createText(this._el_194,'\n            ',(null as any));
    this._el_200 = import3.createRenderElement(this.renderer,this._el_194,'h5',new import3.InlineArray2(2,'class','eva-3-h5 center'),(null as any));
    this._el_201 = import3.createRenderElement(this.renderer,this._el_200,'span',new import3.InlineArray2(2,'class','span-modal-new-feature'),(null as any));
    this._text_202 = this.renderer.createText(this._el_201,'',(null as any));
    this._el_203 = import3.createRenderElement(this.renderer,this._el_201,'b',new import3.InlineArray2(2,'class','bold-text'),(null as any));
    this._text_204 = this.renderer.createText(this._el_203,'',(null as any));
    this._text_205 = this.renderer.createText(this._el_194,'\n        ',(null as any));
    this._text_206 = this.renderer.createText(this._el_177,'\n        ',(null as any));
    this._el_207 = import3.createRenderElement(this.renderer,this._el_177,'div',new import3.InlineArray2(2,'class','modal-coachmark-actions'),(null as any));
    this._text_208 = this.renderer.createText(this._el_207,'\n            ',(null as any));
    this._el_209 = import3.createRenderElement(this.renderer,this._el_207,'button',new import3.InlineArray2(2,'class','eva-3-btn-ghost -lg -eva-3-fwidth-small -darken center'),(null as any));
    this._text_210 = this.renderer.createText(this._el_209,'',(null as any));
    this._text_211 = this.renderer.createText(this._el_207,'\n        ',(null as any));
    this._text_212 = this.renderer.createText(this._el_177,'\n    ',(null as any));
    this._text_213 = this.renderer.createText(this._el_175,'\n',(null as any));
    this._text_214 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_69,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_69));
    this._pipe_translate_8 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_9 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_10 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_99,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_99));
    this._pipe_translate_11 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_12 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_13 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_124,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_124));
    this._pipe_translate_14 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_142,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_142));
    this._pipe_translate_15 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_16 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_168,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_168));
    this._pipe_translate_17 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_180,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_180));
    this._pipe_translate_18 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_19 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_20 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_21 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_6:Function = import3.subscribeToRenderElement(this,this._el_209,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_209));
    this._pipe_translate_22 = new import21.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._anchor_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._text_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._el_54,
      this._el_55,
      this._text_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._text_71,
      this._text_72,
      this._text_73,
      this._text_74,
      this._el_75,
      this._text_76,
      this._anchor_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._el_84,
      this._el_85,
      this._text_86,
      this._text_87,
      this._el_88,
      this._text_89,
      this._el_90,
      this._text_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._text_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._el_99,
      this._text_100,
      this._text_101,
      this._text_102,
      this._text_103,
      this._text_104,
      this._el_105,
      this._text_106,
      this._el_107,
      this._text_108,
      this._el_109,
      this._el_110,
      this._text_111,
      this._text_112,
      this._el_113,
      this._text_114,
      this._el_115,
      this._text_116,
      this._text_117,
      this._el_118,
      this._text_119,
      this._text_120,
      this._text_121,
      this._el_122,
      this._text_123,
      this._el_124,
      this._text_125,
      this._text_126,
      this._text_127,
      this._text_128,
      this._text_129,
      this._text_130,
      this._text_131,
      this._text_132,
      this._text_133,
      this._text_134,
      this._text_135,
      this._text_136,
      this._el_137,
      this._text_138,
      this._el_139,
      this._text_140,
      this._el_141,
      this._el_142,
      this._text_143,
      this._el_144,
      this._el_145,
      this._text_146,
      this._el_147,
      this._text_148,
      this._el_149,
      this._text_150,
      this._el_151,
      this._text_152,
      this._text_153,
      this._text_154,
      this._el_155,
      this._text_156,
      this._el_157,
      this._text_158,
      this._el_159,
      this._el_160,
      this._text_161,
      this._text_162,
      this._text_163,
      this._el_164,
      this._text_165,
      this._el_166,
      this._text_167,
      this._el_168,
      this._text_169,
      this._text_170,
      this._text_171,
      this._text_172,
      this._text_173,
      this._text_174,
      this._el_175,
      this._text_176,
      this._el_177,
      this._text_178,
      this._el_179,
      this._el_180,
      this._text_181,
      this._el_182,
      this._el_183,
      this._text_184,
      this._el_185,
      this._text_186,
      this._el_187,
      this._text_188,
      this._text_189,
      this._el_190,
      this._text_191,
      this._text_192,
      this._text_193,
      this._el_194,
      this._text_195,
      this._el_196,
      this._el_197,
      this._text_198,
      this._text_199,
      this._el_200,
      this._el_201,
      this._text_202,
      this._el_203,
      this._text_204,
      this._text_205,
      this._text_206,
      this._el_207,
      this._text_208,
      this._el_209,
      this._text_210,
      this._text_211,
      this._text_212,
      this._text_213,
      this._text_214
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import31.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    if (((token === import28.DateService) && (31 === requestNodeIndex))) { return this._DateService_31_3; }
    if (((token === import27.PickupWeekComponent) && (31 === requestNodeIndex))) { return this._PickupWeekComponent_31_4.context; }
    if (((token === import30.TemplateRef) && (77 === requestNodeIndex))) { return this._TemplateRef_77_5; }
    if (((token === import31.NgIf) && (77 === requestNodeIndex))) { return this._NgIf_77_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import23.ValueUnwrapper();
    const currVal_11_0_0:any = this.context.showMessageBanner;
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.ngDoCheck(this,this._anchor_11,throwOnChange);
    const currVal_31_0_0:any = this.context.pickupList;
    this._PickupWeekComponent_31_4.check_pickupList(currVal_31_0_0,throwOnChange,false);
    this._PickupWeekComponent_31_4.ngDoCheck(this,this._el_31,throwOnChange);
    const currVal_77_0_0:any = this.context.showCountryPhone;
    this._NgIf_77_6.check_ngIf(currVal_77_0_0,throwOnChange,false);
    this._NgIf_77_6.ngDoCheck(this,this._anchor_77,throwOnChange);
    this._vc_11.detectChangesInNestedViews(throwOnChange);
    this._vc_77.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_225:any = import3.inlineInterpolate(2,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('home.WELCOME')),'',((this.context.company == null)? (null as any): this.context.company.companyName),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_225,currVal_225))) {
      this.renderer.setText(this._text_16,currVal_225);
      this._expr_225 = currVal_225;
    }
    valUnwrapper.reset();
    const currVal_227:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform(this.context.today.day)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_227,currVal_227))) {
      this.renderer.setText(this._text_22,currVal_227);
      this._expr_227 = currVal_227;
    }
    valUnwrapper.reset();
    const currVal_229:any = import3.inlineInterpolate(3,'',this.context.today.date,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('home.of')),'',valUnwrapper.unwrap(this._pipe_translate_3.transform(this.context.today.month)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_229,currVal_229))) {
      this.renderer.setText(this._text_25,currVal_229);
      this._expr_229 = currVal_229;
    }
    valUnwrapper.reset();
    const currVal_232:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('home.WHAT_WE_DO')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_232,currVal_232))) {
      this.renderer.setText(this._text_45,currVal_232);
      this._expr_232 = currVal_232;
    }
    valUnwrapper.reset();
    const currVal_234:any = import3.inlineInterpolate(1,'  ',valUnwrapper.unwrap(this._pipe_translate_5.transform('home.communications.NEWS_8_DATE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_234,currVal_234))) {
      this.renderer.setText(this._text_56,currVal_234);
      this._expr_234 = currVal_234;
    }
    valUnwrapper.reset();
    const currVal_236:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_6.transform('home.communications.NEWS_8_TITLE')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_236,currVal_236))) {
      this.renderer.setText(this._text_61,currVal_236);
      this._expr_236 = currVal_236;
    }
    valUnwrapper.reset();
    const currVal_238:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_7.transform('home.communications.NEWS_8_DESCRIPTION')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_238,currVal_238))) {
      this.renderer.setText(this._text_64,currVal_238);
      this._expr_238 = currVal_238;
    }
    valUnwrapper.reset();
    const currVal_240:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_8.transform('home.communications.NEWS_8_LINK')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_240,currVal_240))) {
      this.renderer.setText(this._text_70,currVal_240);
      this._expr_240 = currVal_240;
    }
    valUnwrapper.reset();
    const currVal_242:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_9.transform('home.communications.NEWS_10_TITLE')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_242,currVal_242))) {
      this.renderer.setText(this._text_91,currVal_242);
      this._expr_242 = currVal_242;
    }
    valUnwrapper.reset();
    const currVal_244:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_10.transform('home.communications.NEWS_10_DESCRIPTION')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_244,currVal_244))) {
      this.renderer.setText(this._text_94,currVal_244);
      this._expr_244 = currVal_244;
    }
    valUnwrapper.reset();
    const currVal_246:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_11.transform('home.communications.NEWS_10_LINK')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_246,currVal_246))) {
      this.renderer.setText(this._text_100,currVal_246);
      this._expr_246 = currVal_246;
    }
    valUnwrapper.reset();
    const currVal_248:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_12.transform('home.communications.NEWS_9_TITLE')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_248,currVal_248))) {
      this.renderer.setText(this._text_116,currVal_248);
      this._expr_248 = currVal_248;
    }
    valUnwrapper.reset();
    const currVal_250:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_13.transform('home.communications.NEWS_9_DESCRIPTION')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_250,currVal_250))) {
      this.renderer.setText(this._text_119,currVal_250);
      this._expr_250 = currVal_250;
    }
    valUnwrapper.reset();
    const currVal_252:any = import3.inlineInterpolate(1,'\n                                        ',valUnwrapper.unwrap(this._pipe_translate_14.transform('home.communications.NEWS_9_LINK')),'\n                                    ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_252,currVal_252))) {
      this.renderer.setText(this._text_125,currVal_252);
      this._expr_252 = currVal_252;
    }
    valUnwrapper.reset();
    const currVal_254:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_15.transform('contract.terms.modal.new_feature.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_254,currVal_254))) {
      this.renderer.setText(this._text_152,currVal_254);
      this._expr_254 = currVal_254;
    }
    valUnwrapper.reset();
    const currVal_256:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_16.transform('contract.terms.modal.new_feature.message')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_256,currVal_256))) {
      this.renderer.setText(this._text_161,currVal_256);
      this._expr_256 = currVal_256;
    }
    valUnwrapper.reset();
    const currVal_258:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_17.transform('contract.terms.modal.new_feature.button.understood')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_258,currVal_258))) {
      this.renderer.setText(this._text_169,currVal_258);
      this._expr_258 = currVal_258;
    }
    valUnwrapper.reset();
    const currVal_260:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_18.transform('contract.terms.modal.contract_expired.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_260,currVal_260))) {
      this.renderer.setText(this._text_188,currVal_260);
      this._expr_260 = currVal_260;
    }
    valUnwrapper.reset();
    const currVal_262:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_19.transform('contract.terms.modal.contract_expired.title2')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_262,currVal_262))) {
      this.renderer.setText(this._text_191,currVal_262);
      this._expr_262 = currVal_262;
    }
    valUnwrapper.reset();
    const currVal_264:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_20.transform('contract.terms.modal.contract_expired.message')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_264,currVal_264))) {
      this.renderer.setText(this._text_198,currVal_264);
      this._expr_264 = currVal_264;
    }
    valUnwrapper.reset();
    const currVal_266:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_21.transform('contract.terms.modal.contract_expired.message2')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_266,currVal_266))) {
      this.renderer.setText(this._text_202,currVal_266);
      this._expr_266 = currVal_266;
    }
    const currVal_268:any = import3.inlineInterpolate(1,' ',this.context.emailExecutiveAccount,'');
    if (import3.checkBinding(throwOnChange,this._expr_268,currVal_268)) {
      this.renderer.setText(this._text_204,currVal_268);
      this._expr_268 = currVal_268;
    }
    valUnwrapper.reset();
    const currVal_269:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_22.transform('contract.terms.modal.contract_expired.button.understood')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_269,currVal_269))) {
      this.renderer.setText(this._text_210,currVal_269);
      this._expr_269 = currVal_269;
    }
    this.compView_31.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if (this._viewQuery_dspCards_0.dirty) {
      this._viewQuery_dspCards_0.reset([
        new import32.ElementRef(this._el_52),
        new import32.ElementRef(this._el_107)
      ]
      );
      this.context.dspCards = this._viewQuery_dspCards_0;
      this._viewQuery_dspCards_0.notifyOnChanges();
    } }
  }
  destroyInternal():void {
    this._vc_11.destroyNestedViews();
    this._vc_77.destroyNestedViews();
    this.compView_31.destroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
    this._pipe_translate_14.ngOnDestroy();
    this._pipe_translate_15.ngOnDestroy();
    this._pipe_translate_16.ngOnDestroy();
    this._pipe_translate_17.ngOnDestroy();
    this._pipe_translate_18.ngOnDestroy();
    this._pipe_translate_19.ngOnDestroy();
    this._pipe_translate_20.ngOnDestroy();
    this._pipe_translate_21.ngOnDestroy();
    this._pipe_translate_22.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 11)) { return new View_HomeComponent1(this.viewUtils,this,11,this._anchor_11,this._vc_11); }
    if ((nodeIndex == 77)) { return new View_HomeComponent2(this.viewUtils,this,77,this._anchor_77,this._vc_77); }
    return (null as any);
  }
  handleEvent_69(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.goTo({
        company: this.context.companyId,
        url: 'carTemplate/picture/PENDING_IMAGE_UPDATE'
      }
      ,'Texto_boton','home.communications.NEWS_8_TITLE')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_99(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.goTo({
        company: this.context.companyId,
        url: 'insurancePrice'
      }
      ,'Texto_boton','home.communications.NEWS_10_TITLE')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_124(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.goTo({
        company: this.context.companyId,
        url: 'pointOfSale'
      }
      ,'Texto_boton','home.communications.NEWS_9_TITLE')) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_142(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.showModalNewFeatureTyC(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_168(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.closeModalNewFeatureTyC()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_180(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.showModalContractExpired(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_209(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.closeModalContractExpired()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/home/home.component.ngfactory.ts